/* GOOSEBERRY PDP — behaviour for sections/main-product-pdp.liquid (variants, cart, gallery, sticky bar,
   wishlist, size chart, Complete the look + quick view). Static and cached; per-page values come from
   the JSON config printed by snippets/gb-pdp-script.liquid. Loaded with defer. */
(function () {
    'use strict';
    var root = document.querySelector('.gbpdp[data-gb-pdp]') || document.querySelector('.gbpdp');
    if (!root || root.dataset.gbInit) return;
    root.dataset.gbInit = '1';
    var cfgEl = root.querySelector('[data-gb-pdp-config]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};

    var data = JSON.parse(root.querySelector('[data-gb-product-json]').textContent);
    var bundlePct = parseFloat(root.dataset.bundlePct); if (isNaN(bundlePct)) bundlePct = 10;
    var state = {
      variant: data.variants.find(function (v) { return v.id === data.selectedVariantId; }) || data.variants[0]
    };
    var looks = []; /* Complete the look pieces — see below */

    /* ---------------- utils ---------------- */
    /* one price format across the page (matches snippets/gb-money.liquid): $79.00 in the US, $129.00 AUD for
       other dollar currencies, €79.00 / £65.00 elsewhere, no decimals for IDR / JPY / KRW... */
    var NODEC = /^(IDR|JPY|KRW|VND|HUF|CLP|ISK|TWD|COP|PYG|UGX|XAF|XOF)$/;
    /* separators come from the shop's own format for this currency (cfg.moneySample = 1234567.89 formatted
       by Liquid), so Rp1.449.000 / €1.234,56 / $1,234.56 match what the page first rendered */
    var ms = String(cfg.moneySample || '1,234,567.89');
    var decSep = /\d/.test(ms.charAt(ms.length - 3)) ? '' : ms.charAt(ms.length - 3);
    var thouSep = (ms.slice(0, decSep ? ms.length - 3 : ms.length).match(/\D/) || [''])[0];
    function fmtMoney(cents) {
      var iso = data.currencyIso || '', sym = data.currencySymbol || '';
      var d = (NODEC.test(iso) || !decSep) ? 0 : 2;
      var parts = (cents / 100).toFixed(d).split('.');
      var out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep) + (d ? decSep + parts[1] : '');
      return sym + out + (sym.indexOf('$') > -1 && iso && iso !== 'USD' ? ' ' + iso : '');
    }
    var fmtSymbol = fmtMoney;
    function q(sel) { return root.querySelector(sel); }
    function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function track(event, payload) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: event, product_id: data.id, variant_id: state.variant && state.variant.id }, payload || {}));
        document.dispatchEvent(new CustomEvent('gbpdp:' + event, { detail: payload || {} }));
      } catch (e) { /* no-op */ }
    }

    /* ---------------- variant engine (size) ---------------- */
    function findVariantBySize(size) {
      return data.variants.find(function (v) { return v.size === size; });
    }
    function updateVariantUI() {
      var v = state.variant;
      if (!v) return;
      var priceEl = q('[data-gb-price]');
      if (priceEl) priceEl.textContent = fmtMoney(v.price);
      var apEl = q('[data-gb-afterpay]');
      if (apEl) apEl.textContent = fmtSymbol(Math.round(v.price / 4));
      var skuEl = q('[data-gb-sku]');
      if (skuEl) skuEl.textContent = v.sku;
      var sizeLabel = q('[data-gb-size-label]');
      if (sizeLabel && v.size) sizeLabel.textContent = v.size;
      var dockSelect = q('[data-gb-dock-select]');
      if (dockSelect && v.size && dockSelect.value !== v.size) dockSelect.value = v.size;
      var dockPrice = q('[data-gb-dock-price]');
      if (dockPrice) dockPrice.textContent = fmtMoney(v.price);
      var lionEl = q('[data-lion-points-for]');
      if (lionEl && lionEl.getAttribute('data-lion-points-for') !== String(v.price)) {
        lionEl.setAttribute('data-lion-points-for', v.price);
        try { if (window.loyaltylion && typeof window.loyaltylion.refresh === 'function') window.loyaltylion.refresh(); } catch (e) {}
      }

      // cross out sibling colors that don't have the selected size in stock
      syncSwatchSizeAvail(v.size);

      var bisBtn = q('[data-gb-bis]');
      if (bisBtn) { bisBtn.hidden = v.available; bisBtn.textContent = bisLabel(v); }
      var mainAtc = q('[data-gb-atc]');
      if (mainAtc && bisBtn) mainAtc.hidden = !v.available; // BIS replaces the sold-out button

      [q('[data-gb-atc]'), q('[data-gb-atc-sticky]')].forEach(function (btn) {
        if (!btn) return;
        /* sticky bar: a sold-out size turns the button into "Notify me" when back-in-stock is on */
        var notify = !v.available && !!bisBtn && btn.hasAttribute('data-gb-atc-sticky');
        btn.disabled = !v.available && !notify;
        btn.classList.toggle('gb-notify', notify);
        var lbl = btn.querySelector('[data-gb-atc-label]');
        var text = v.available ? (cfg.atcLabel || 'Add to cart') : notify ? 'Notify me' : (cfg.soldoutLabel || 'Sold out');
        if (lbl) lbl.textContent = text; else btn.textContent = text;
      });

      // keep ?variant= in URL for shareability
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* no-op */ }

      // wishlist buttons track selected variant
      qa('[data-gb-wishlist]').forEach(function (b) { b.dataset.variantId = v.id; });

      syncSetModule();
    }

    /* Swatches: cross out colors where the currently selected size is sold out.
       Each swatch carries a size→availability map for its sibling product. */
    function syncSwatchSizeAvail(size) {
      qa('[data-gb-swatch][data-size-avail]').forEach(function (sw) {
        if (sw.classList.contains('sel')) { sw.classList.remove('nosize'); return; }
        var map;
        try { map = JSON.parse(sw.dataset.sizeAvail); } catch (e) { return; }
        var noSize = !!size && (size in map) && !map[size];
        // sizes missing from the map (different size range) count as unavailable too
        if (!!size && !(size in map)) noSize = true;
        sw.classList.toggle('nosize', noSize);
        var base = sw.dataset.label || '';
        if (noSize) {
          sw.setAttribute('aria-label', base + ' — unavailable in ' + size);
          sw.title = base + ' — unavailable in ' + size;
        } else if (!sw.classList.contains('oos')) {
          sw.setAttribute('aria-label', base);
          sw.title = base;
        }
      });
    }

    qa('[data-gb-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qa('[data-gb-size]').forEach(function (b) {
          b.classList.remove('sel');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('sel');
        btn.setAttribute('aria-checked', 'true');
        var v = findVariantBySize(btn.dataset.value);
        if (v) {
          state.variant = v;
          resetLooks(); // unpinned pieces re-match the new size
          updateVariantUI();
          track('select_variant', { option: 'size', value: v.size });
        }
      });
    });

    /* Back in stock — Omnisend. Omnisend's app embed checks the product page every second and reads the
       selected variant from ?variant= in the URL (kept up to date above), so its back-in-stock form
       subscribes the shopper to the size she picked. We wait until Omnisend has caught up with the
       selection, then open the form (set to "custom trigger only" in Omnisend). */
    var bisEl = q('[data-gb-bis]');
    function bisLabel(v) {
      var t = (bisEl && bisEl.getAttribute('data-label')) || 'Notify me when back in stock';
      return v && v.size ? t.replace('{size}', v.size) : t.replace(/\s*\{size\}\s*/, ' ');
    }
    function openBis(source) {
      var v = state.variant;
      if (!v || v.available || !cfg.bisFormId) return;
      track('notify_me_click', { variant_id: v.id, source: source || 'buy_box' });
      var want = String(v.id), tries = 0;
      (function go() {
        var info = null;
        try { info = window._omnisend && window._omnisend.getProductInfo && window._omnisend.getProductInfo(); } catch (e) { /* not loaded yet */ }
        if ((info && String(info.variantID) === want && info.status === 'outOfStock') || ++tries > 25) {
          window.omnisend = window.omnisend || [];
          window.omnisend.push(['openForm', cfg.bisFormId]);
          return;
        }
        setTimeout(go, 120);
      })();
    }
    if (bisEl) bisEl.addEventListener('click', function (e) { e.preventDefault(); openBis('buy_box'); });

    /* Sticky-bar size selector: route through the same selection path as the pills */
    var dockSelectEl = q('[data-gb-dock-select]');
    if (dockSelectEl) {
      dockSelectEl.addEventListener('change', function () {
        var pill = qa('[data-gb-size]').find(function (b) { return b.dataset.value === dockSelectEl.value; });
        if (pill) { pill.click(); return; }
        var v = findVariantBySize(dockSelectEl.value);
        if (v) { state.variant = v; resetLooks(); updateVariantUI(); track('select_variant', { option: 'size', value: v.size, source: 'sticky_bar' }); }
      });
    }

    // initial swatch availability state
    syncSwatchSizeAvail(state.variant && state.variant.size);

    /* ---------------- cart ---------------- */
    function openCartDrawer(sections) {
      /* Store-proven choreography (same as the collection-page quick add in
         custom-js.liquid): refresh the drawer with the inline section HTML
         first, then open it after 500ms so the open animation runs against
         settled DOM (trimmed from 500ms to 120ms on 1 Oct: the add itself already takes ~1s, and
         SimGym flagged the wait). If the drawer is already open (e.g. a second add), skip
         the icon click — re-triggering the open sequence double-activates the
         theme's focus trap and scroll lock. */
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { sections: sections } }));
      if (!cfg.disableDrawerOpen) {
      setTimeout(function () {
        var alreadyOpen = document.querySelector('.quick-cart__wrapper.active') ||
          document.body.getAttribute('data-fluorescent-overlay-open') === 'true';
        if (!alreadyOpen) {
          var icon = document.querySelector('a[data-js-cart-icon]') || document.querySelector('[data-js-cart-icon]');
          if (icon) icon.click();
        }
        /* Watchdog: if the page ends up scroll-locked with no visible drawer
           (overlay conflict with another app), force-release the lock. */
        setTimeout(function () {
          var wrapper = document.querySelector('.quick-cart__wrapper.active');
          var visible = wrapper && wrapper.getBoundingClientRect().width > 10 &&
            parseFloat(getComputedStyle(wrapper).opacity || '1') > 0.1;
          var locked = document.body.style.overflow === 'hidden' ||
            getComputedStyle(document.body).overflow === 'hidden' ||
            document.body.style.position === 'fixed';
          if (locked && !visible) {
            console.warn('[gbpdp] releasing orphaned scroll lock');
            var topWas = parseInt(document.body.style.top || '0', 10);
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.paddingRight = '';
            document.body.removeAttribute('data-fluorescent-overlay-open');
            if (topWas) window.scrollTo(0, -topWas);
          }
        }, 1500);
      }, 120);
      }
    }
    function addItems(items, onDone, onError) {
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'quick-cart' })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      }).then(function (res) {
        openCartDrawer(res.sections);
        if (onDone) onDone(res);
      }).catch(function (err) {
        console.error('[gbpdp] add to cart failed', err);
        if (onError) onError(err);
        alert((err && err.description) || 'Sorry — this item could not be added to your cart.');
      });
    }
    /* fit-finder attribution (_fit_finder / _fit_finder_selected) travels on the line item — see assets/gb-fit-finder.js */
    function fitProps() {
      try { return (window.GBFitFinder && window.GBFitFinder.lineProps) ? window.GBFitFinder.lineProps(data.handle) : {}; } catch (e) { return {}; }
    }
    /* final-sale disclaimer: same line property the classic product form adds (theme settings sale_property_key/value) */
    function saleProps(isFinal, props) {
      props = props || {};
      if (isFinal && cfg.saleKey && cfg.saleValue) props[cfg.saleKey] = cfg.saleValue;
      return props;
    }
    /* Instant feedback while the cart request runs (~1s): the button stays dark and reads "Adding…"
       instead of greying out like a sold-out button. */
    function setBusy(btn, busy) {
      var lbl = btn.querySelector('[data-gb-atc-label]') || btn;
      if (busy) {
        btn.dataset.gbBusy = '1';
        btn.dataset.gbLabel = lbl.textContent;
        lbl.textContent = 'Adding\u2026';
        btn.setAttribute('aria-busy', 'true');
        btn.style.cursor = 'progress';
      } else {
        delete btn.dataset.gbBusy;
        if (btn.dataset.gbLabel) lbl.textContent = btn.dataset.gbLabel;
        btn.removeAttribute('aria-busy');
        btn.style.cursor = '';
      }
    }
    function bindAtc(btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (state.variant && !state.variant.available && btn.classList.contains('gb-notify')) { openBis('sticky_bar'); return; }
        if (!state.variant || !state.variant.available || btn.dataset.gbBusy) return;
        setBusy(btn, true);
        addItems([{ id: state.variant.id, quantity: 1, properties: saleProps(cfg.finalSale, fitProps()) }], function () {
          setBusy(btn, false);
          track('add_to_cart', { price: state.variant.price });
        }, function () { setBusy(btn, false); });
      });
    }
    bindAtc(q('[data-gb-atc]'));
    bindAtc(q('[data-gb-atc-sticky]'));

    /* ---------------- gallery videos: play only while visible ---------------- */
    var vids = qa('.gb-media video, .gb-mslide video');
    if (vids.length && 'IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.intersectionRatio >= 0.5) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: [0, 0.5] });
      vids.forEach(function (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        vio.observe(v);
      });
    }

    /* ---------------- sticky dock ---------------- */
    var dock = q('[data-gb-dock]');
    if (dock) {
      var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
      var stickyDesktop = dock.dataset.stickyDesktop === 'true';
      var stickyMobile = dock.dataset.stickyMobile === 'true';
      var mainAtc = q('[data-gb-atc]');
      var dockShown = false;
      function setDock(on) {
        dock.classList.toggle('visible', on);
        dock.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on && !dockShown) { dockShown = true; track('sticky_atc_view'); }
      }
      function evalDock() {
        var enabled = isDesktop() ? stickyDesktop : stickyMobile;
        if (!enabled || !mainAtc) {
          setDock(false);
          document.body.classList.remove('gb-has-mobile-dock');
          return;
        }
        /* both breakpoints: reveal only after the in-page ATC has been scrolled PAST
           (above the viewport) — not while it's still waiting below the fold */
        var r = mainAtc.getBoundingClientRect();
        var off = r.bottom < 0;
        setDock(off);
        document.body.classList.toggle('gb-has-mobile-dock', off && !isDesktop());
      }
      evalDock();
      window.addEventListener('scroll', evalDock, { passive: true });
      window.addEventListener('resize', evalDock);
    }

    /* ---------------- gallery ---------------- */
    var viewMore = q('[data-gb-viewmore]');
    if (viewMore) {
      viewMore.addEventListener('click', function () {
        qa('.gb-media.gb-hidden-media').forEach(function (m) { m.classList.remove('gb-hidden-media'); });
        viewMore.setAttribute('aria-expanded', 'true');
        viewMore.closest('.gb-viewmore').style.display = 'none';
      });
    }
    var lightbox = q('[data-gb-lightbox]');
    var lbImg = lightbox ? lightbox.querySelector('img') : null;
    var lbCount = q('[data-gb-lightbox-count]');
    // unique full-size gallery (desktop grid + mobile track both render every image)
    var lbGallery = [];
    qa('[data-gb-zoom]').forEach(function (m) {
      if (lbGallery.indexOf(m.dataset.full) < 0) lbGallery.push(m.dataset.full);
    });
    var lbIndex = 0;
    function lbResetZoom() {
      if (!lbImg) return;
      lbImg.classList.remove('zoomed');
      lbImg.style.transition = '';
      lbImg.style.transformOrigin = 'center center';
    }
    var lbLoaded = {};
    function lbPreload(i) {
      var u = lbGallery[(i + lbGallery.length) % lbGallery.length];
      if (!u || lbLoaded[u]) return;
      var im = new Image(); im.onload = function () { lbLoaded[u] = true; }; im.src = u;
    }
    function lbShow(i, placeholderSrc) {
      if (!lbImg || !lbGallery.length) return;
      lbIndex = (i + lbGallery.length) % lbGallery.length;
      lbResetZoom();
      var full = lbGallery[lbIndex];
      if (lbLoaded[full]) {
        lbImg.src = full;
      } else {
        /* show the already-downloaded gallery-size image instantly,
           swap in the hi-res as soon as it lands */
        if (placeholderSrc) lbImg.src = placeholderSrc;
        var hi = new Image();
        hi.onload = function () {
          lbLoaded[full] = true;
          if (lbGallery[lbIndex] === full) lbImg.src = full;
        };
        hi.src = full;
      }
      if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + lbGallery.length;
      lbPreload(lbIndex + 1); lbPreload(lbIndex - 1);
    }
    qa('[data-gb-zoom]').forEach(function (m) {
      m.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); m.click(); }
      });
      m.addEventListener('click', function () {
        if (!lightbox) return;
        var ph = m.tagName === 'IMG' ? (m.currentSrc || m.src) :
          (m.querySelector && m.querySelector('img') ? m.querySelector('img').currentSrc :
            (m.style && m.style.backgroundImage ? m.style.backgroundImage.slice(5, -2) : ''));
        lbShow(lbGallery.indexOf(m.dataset.full), ph);
        lightbox.hidden = false;
        lightbox.classList.add('open');
      });
    });
    if (lightbox) {
      function closeLightbox() { lightbox.classList.remove('open'); lightbox.hidden = true; lbResetZoom(); }
      var lbPrev = q('[data-gb-lightbox-prev]');
      var lbNext = q('[data-gb-lightbox-next]');
      if (lbPrev) lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); });
      // click the image to magnify at that spot; move to pan; click again to reset
      if (lbImg) {
        lbImg.addEventListener('click', function (e) {
          var r = lbImg.getBoundingClientRect();
          var ox = ((e.clientX - r.left) / r.width) * 100;
          var oy = ((e.clientY - r.top) / r.height) * 100;
          if (lbImg.classList.contains('zoomed')) { lbResetZoom(); return; }
          lbImg.style.transition = '';
          lbImg.style.transformOrigin = ox + '% ' + oy + '%';
          lbImg.classList.add('zoomed');
        });
        lbImg.addEventListener('mousemove', function (e) {
          if (!lbImg.classList.contains('zoomed')) return;
          var r = lightbox.querySelector('[data-gb-lightbox-stage]').getBoundingClientRect();
          var ox = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
          var oy = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
          lbImg.style.transition = 'none';
          lbImg.style.transformOrigin = ox + '% ' + oy + '%';
        });
      }
      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('open')) return;
        if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
        if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
      });
      // close on backdrop or × only, so magnifying the image doesn't dismiss it
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target.closest('[data-gb-lightbox-close]')) closeLightbox(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lightbox.classList.contains('open')) { lightbox.classList.remove('open'); lightbox.hidden = true; } });
    }
    // mobile thumbs <-> track sync
    var mtrack = q('[data-gb-mtrack]');
    var mthumbs = qa('[data-gb-mthumb]');
    if (mtrack && mthumbs.length) {
      mthumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = parseInt(t.dataset.index, 10);
          mtrack.scrollTo({ left: idx * mtrack.clientWidth, behavior: 'smooth' });
        });
      });
      var scrollT;
      mtrack.addEventListener('scroll', function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(function () {
          var idx = Math.round(mtrack.scrollLeft / mtrack.clientWidth);
          mthumbs.forEach(function (t, i) { t.classList.toggle('sel', i === idx); });
        }, 80);
      }, { passive: true });
    }

    /* ---------------- accordions ---------------- */
    qa('[data-gb-accord]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = panel.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('.gb-accord-icon').textContent = open ? '−' : '+';
      });
    });

    /* ---------------- size chart (Kiwi) / size finder (fit-quiz popup) ---------------- */
    function openModal(m) { if (!m) return; m.hidden = false; document.documentElement.classList.add('gb-modal-open'); requestAnimationFrame(function () { m.classList.add('open'); }); }
    function closeModal(m) { if (!m) return; m.classList.remove('open'); m.hidden = true; document.documentElement.classList.remove('gb-modal-open'); }
    var scModal = q('[data-gb-sizechart-modal]');
    qa('[data-gb-modal-close]').forEach(function (c) {
      c.addEventListener('click', function () { closeModal(c.closest('.gb-modal')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeModal(scModal); }
    });

    /* Size chart: our own table (size_chart metaobject) when the product has one; otherwise the Kiwi
       app's chart — Kiwi's embed injects a modal link into the hidden #KiwiSizingChart placeholder and
       our button forwards the click. The Kiwi button (and a card holding nothing else) stays hidden
       until Kiwi has actually produced a chart for this product. */
    var scBtn = q('[data-gb-sizechart]');
    function kiwiLink() {
      return document.querySelector('#KiwiSizingChart .ks-chart-modal-link') ||
        document.querySelector('#KiwiSizingChart a, #KiwiSizingChart span[onclick], #KiwiSizingChart button');
    }
    if (scBtn) {
      var scSource = scBtn.getAttribute('data-gb-sc-source');
      scBtn.addEventListener('click', function () {
        track('size_chart_open', { source: scSource });
        if (scSource === 'chart') { openModal(scModal); return; }
        var k = kiwiLink(); if (k) k.click();
      });
      if (scSource === 'kiwi') {
        var fitCard = q('[data-gb-fitcard]');
        var kTries = 0;
        var kTimer = setInterval(function () {
          if (kiwiLink()) {
            clearInterval(kTimer);
            scBtn.hidden = false;
            if (fitCard && fitCard.hasAttribute('data-gb-fit-kiwi-only')) fitCard.hidden = false;
          } else if (++kTries > 40) { clearInterval(kTimer); } /* ~12s: no Kiwi chart -> stays hidden */
        }, 300);
      }
    }
    /* cm / in toggle on our size chart */
    var scTable = q('[data-gb-sc]');
    if (scTable) {
      var toIn = function (txt) {
        return txt.replace(/\d+(?:\.\d+)?/g, function (n) { return (Math.round(parseFloat(n) / 2.54 * 10) / 10).toString(); });
      };
      scTable.querySelectorAll('[data-gb-sc-unit]').forEach(function (b) {
        b.addEventListener('click', function () {
          var unit = b.getAttribute('data-gb-sc-unit');
          scTable.querySelectorAll('[data-gb-sc-unit]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          scTable.querySelectorAll('td[data-cm]').forEach(function (td) {
            var cm = td.getAttribute('data-cm');
            if (!cm) return;
            td.textContent = unit === 'in' ? toIn(cm) : cm;
          });
        });
      });
    }

    /* Find my size: the Gooseberry fit finder (assets/gb-fit-finder.js) opens on any [data-gbf-open] click;
       the size_finder_open analytics event fires through the data-gb-analytics binding below. */
    qa('[data-gb-analytics]').forEach(function (el) {
      el.addEventListener('click', function () { track(el.dataset.gbAnalytics, { detail: el.dataset.gbAnalyticsDetail }); });
    });

    /* ---------------- wishlist ---------------- */
    var WL_KEY = 'gb_wishlist_guest';
    function wlLocal() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
    function wlLocalSave(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }
    function wlHasKing() {
        /* toolkit.config is set by the app's init() — calling the SDK before
           that wedges its collection cache and breaks all saves on the page */
        try { return !!(window.WishlistKing && window.WishlistKing.toolkit && window.WishlistKing.toolkit.config); }
        catch (e) { return false; }
      }
    /* Wishlist King v5 SDK (@appmate/wishlist 5.x): no .toolkit — it exposes addWishlistItem /
       removeWishlistItem on window.WishlistKing instead. The ids it returns are kept per product so
       the heart can be un-saved; saves go to the same list the /apps/wishlist page shows. */
    var WK_MAP = 'gb_wk_items';
    function wlNew() { try { return !!(window.WishlistKing && typeof window.WishlistKing.addWishlistItem === 'function' && !window.WishlistKing.toolkit); } catch (e) { return false; } }
    function wkMap() { try { return JSON.parse(localStorage.getItem(WK_MAP) || '{}'); } catch (e) { return {}; } }
    function wkMapSave(m) { try { localStorage.setItem(WK_MAP, JSON.stringify(m)); } catch (e) {} }
    function wlContains(cb) {
      if (wlNew()) { cb(!!wkMap()[data.id]); return; }
      if (wlHasKing()) {
        try {
          window.WishlistKing.toolkit.collection.get().then(function (list) {
            cb(list && list.containsProduct && list.containsProduct(data.id));
          }).catch(function () { cb(false); });
          return;
        } catch (e) { /* fall through */ }
      }
      cb(wlLocal().indexOf(data.id) > -1);
    }
    function wlSetUI(saved) {
      qa('[data-gb-wishlist]').forEach(function (b) {
        b.classList.toggle('saved', saved);
        b.textContent = saved ? '♥' : '♡';
        b.setAttribute('aria-pressed', saved ? 'true' : 'false');
        b.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
      });
    }
    function wlVerify(expected, btn) {
      /* trust but verify: 900ms later ask the SDK collection what it thinks;
         if the API call quietly failed, proxy through the app's own button */
      setTimeout(function () {
        if (!wlHasKing()) return;
        try {
          window.WishlistKing.toolkit.collection.get().then(function (list) {
            var actual = !!(list && list.containsProduct && list.containsProduct(data.id));
            console.log('[gbpdp] wishlist verify: in wishlist =', actual, '(expected', expected + ')');
            if (actual === expected) { wlSetUI(actual); return; }
            var native = document.querySelector('[data-gb-wk-native] [data-wk-add-product], [data-gb-wk-native] [data-wk-remove-product], [data-gb-wk-native] .wk-button');
            if (native) {
              console.warn('[gbpdp] wishlist verify mismatch — proxying native button');
              native.click();
              setTimeout(function () { wlContains(wlSetUI); }, 900);
            } else { wlSetUI(actual); }
          }).catch(function () {});
        } catch (e) {}
      }, 900);
    }
    qa('[data-gb-wishlist]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        wlContains(function (saved) {
          var next = !saved;
          if (wlNew()) {
            var WK5 = window.WishlistKing, m = wkMap();
            var pr5 = next
              ? WK5.addWishlistItem({ productId: String(data.id), variantId: String(btn.dataset.variantId || ''), productHandle: data.handle })
              : (m[data.id] ? WK5.removeWishlistItem({ wishlistItemId: m[data.id] }) : Promise.resolve(null));
            Promise.resolve(pr5).then(function (r) {
              var mm = wkMap();
              if (next && r && r.wishlistItem) mm[data.id] = r.wishlistItem.id; else delete mm[data.id];
              wkMapSave(mm);
            }).catch(function (err) {
              console.warn('[gbpdp] wishlist v5 failed:', err && err.message || err);
              wlSetUI(!next);
            });
            wlSetUI(next);
            track(next ? 'wishlist_add' : 'wishlist_remove');
            return;
          }
          if (wlHasKing()) {
            var fn = next ? 'addProduct' : 'removeProduct';
            try {
              var p = window.WishlistKing.toolkit[fn](data.id, parseInt(btn.dataset.variantId, 10));
              if (p && p.then) p.then(function () {
                console.log('[gbpdp] wishlist ' + fn + ' OK — verify at /pages/wishlist');
              });
              if (p && p.catch) p.catch(function (err) {
                console.warn('[gbpdp] wishlist ' + fn + ' failed:', err && err.message || err);
                if (err && err.message === 'OPERATION_IN_PROGRESS') return; // double-tap, first one wins
                wlSetUI(!next); // revert — the heart never lies
                if (String(err).indexOf('Login required') > -1) {
                  window.location = '/account/login?wk-redirect=' + encodeURIComponent(JSON.stringify({
                    path: window.location.pathname,
                    intent: { action: 'addProduct', product: data.id, variant: parseInt(btn.dataset.variantId, 10) }
                  }));
                }
              });
            } catch (e) { console.warn('[gbpdp] wishlist error', e); wlSetUI(!next); }
          } else {
            var arr = wlLocal();
            if (next) { if (arr.indexOf(data.id) < 0) arr.push(data.id); }
            else { arr = arr.filter(function (id) { return id !== data.id; }); }
            wlLocalSave(arr);
          }
          wlSetUI(next);
          wlVerify(next, btn);
          track(next ? 'wishlist_add' : 'wishlist_remove');
        });
      });
    });
    // Mount Wishlist King's own button component in both heart positions —
    // the identical code path the app uses everywhere it works. The custom
    // fallback hearts only appear if the app never initializes on this page.
    (function () {
      var mounts = qa('[data-gb-wk-mount]');
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (wlNew()) {
          clearInterval(t);
          qa('[data-gb-wishlist]').forEach(function (fb) { fb.hidden = false; });
          wlContains(wlSetUI);
          return;
        }
        if (wlHasKing() && window.WishlistKing.createComponent && mounts.length) {
          clearInterval(t);
          try {
            /* capture the INITIALIZED instance now — the app's embed script
               loads a second SDK copy later and clobbers window.WishlistKing
               with an object that has no .toolkit, which is why the app's own
               click handler (which reads the global at click time) crashes */
            var WK = window.WishlistKing;
            mounts.forEach(function (mountEl) {
              mountEl.appendChild(WK.createComponent('wishlist-button', { id: cfg.productId }));
              mountEl.addEventListener('click', function (ev) {
                var btn = ev.target.closest('[data-wk-add-product],[data-wk-remove-product]');
                if (!btn) return;
                ev.preventDefault(); ev.stopPropagation();
                if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
                if (btn.dataset.gbBusy) return; /* ignore clicks while an action is in flight */
                btn.dataset.gbBusy = '1';
                setTimeout(function () { delete btn.dataset.gbBusy; }, 1200);
                window.WishlistKing = WK; // re-pin the healthy instance
                var adding = btn.hasAttribute('data-wk-add-product');
                var pid = btn.getAttribute(adding ? 'data-wk-add-product' : 'data-wk-remove-product');
                var vId = state.variant && state.variant.id;
                var pr = adding ? WK.toolkit.addProduct(pid, vId) : WK.toolkit.removeProduct(pid);
                if (pr && pr.then) pr.then(function () {
                  console.log('[gbpdp] wishlist ' + (adding ? 'ADDED' : 'REMOVED') + ' ✓ — verify at /pages/wishlist');
                  track(adding ? 'wishlist_add' : 'wishlist_remove');
                }).catch(function (err) { console.warn('[gbpdp] wishlist action failed:', err && err.message || err); });
              }, true); /* capture phase: runs before the app's fragile delegate */
            });
            console.log('[gbpdp] Wishlist King component mounted x' + mounts.length + ' (instance pinned)');
          } catch (e) {
            console.warn('[gbpdp] WK component mount failed — fallback hearts active', e);
            qa('[data-gb-wishlist]').forEach(function (fb) { fb.hidden = false; });
            wlContains(wlSetUI);
          }
        } else if (tries === 20 && window.WishlistKing && window.WishlistKing.toolkit && !window.WishlistKing.toolkit.config) {
          /* SDK loaded but the theme snippet's init never completed — run the
             same init ourselves (verified working with these exact options). */
          console.warn('[gbpdp] Wishlist King loaded but uninitialized — self-healing init');
          import(cfg.wk.templatesUrl).then(function (tmod) {
            try {
              window.WishlistKing.toolkit.init({
                templates: tmod.default || tmod,
                settings: { wishlistPageHandle: 'wishlist', sharedWishlistPageHandle: 'shared-wishlist', moveToCart: false, loginRequired: false },
                app: { proxy: '/apps/wishlist-king' },
                template: cfg.wk.template,
                shop: cfg.wk.shop,
                session: { customer: cfg.wk.customer, customer_email: cfg.wk.customerEmail },
                wishlist: { filter: function (p) { return !p.hidden; }, share: { title: cfg.wk.shop.name, description: '' } },
                theme: {
                  locale: cfg.wk.locale,
                  customer: cfg.wk.customer,
                  customer_accounts_enabled: cfg.wk.customerAccountsEnabled
                }
              });
              console.log('[gbpdp] self-heal init complete:', !!window.WishlistKing.toolkit.config);
            } catch (e) { console.warn('[gbpdp] self-heal init failed', e); }
          }).catch(function (e) { console.warn('[gbpdp] templates import failed', e); });
        } else if (tries > 50) {
          clearInterval(t);
          console.warn('[gbpdp] WK diagnostic:',
            'global=', !!window.WishlistKing,
            'toolkit=', !!(window.WishlistKing && window.WishlistKing.toolkit),
            'config=', !!(window.WishlistKing && window.WishlistKing.toolkit && window.WishlistKing.toolkit.config),
            'createComponent=', !!(window.WishlistKing && window.WishlistKing.createComponent));
          qa('[data-gb-wishlist]').forEach(function (fb) { fb.hidden = false; });
          wlContains(wlSetUI);
        }
      }, 300);
    })();

    /* ---------------- Complete the look (one or more pieces, each added on its own) ----------------
       Each piece auto-matches the size picked above until the shopper chooses its size themselves. */
    function lq(el, sel) { return el ? el.querySelector(sel) : null; }
    function resetLooks() { looks.forEach(function (L) { if (!L.manual) L.v = null; }); }
    function markPills(wrap, pv) {
      if (!wrap) return;
      wrap.querySelectorAll('.gb-pill').forEach(function (x) {
        var on = !!pv && x.dataset.size === pv.size;
        x.classList.toggle('sel', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    var LOOK_ADD = cfg.lookAdd || 'Add to cart';
    var QV_ADD = cfg.atcLabel || 'Add to cart';
    function syncLook(L) {
      if (!L.manual || !L.v) {
        /* the size picked above if that piece has it in stock, otherwise its first in-stock size
           (never preselect a sold-out size); one-size pieces just take their in-stock variant */
        var sz = state.variant && state.variant.size;
        var avail = L.p.variants.filter(function (v) { return v.available; });
        L.v = (!L.oneSize && avail.find(function (v) { return v.size === sz; })) || avail[0] || null;
      }
      var pv = L.v, ok = !!(pv && pv.available);
      var s = lq(L.el, '[data-gb-set-size]'); if (s) s.textContent = pv ? pv.size : (state.variant && state.variant.size) || '—';
      var o = lq(L.el, '[data-gb-set-oos]'); if (o) o.hidden = ok;
      var pr = lq(L.el, '[data-gb-set-price]'); if (pr && pv) pr.textContent = fmtSymbol(pv.price);
      /* matched size sold out -> nothing preselected; the button asks for a size instead of dead-ending */
      var al = lq(L.el, '[data-gb-set-add-label]'); if (al) al.textContent = ok ? LOOK_ADD : 'Choose a size';
      markPills(lq(L.el, '[data-gb-set-sizes]'), L.manual && ok ? pv : null);
      if (L.qv) {
        var qs = lq(L.qv, '[data-gb-qv-size]'); if (qs) qs.textContent = ok ? pv.size : '—';
        var qp = lq(L.qv, '[data-gb-qv-price]'); if (qp && pv) qp.textContent = fmtMoney(pv.price);
        var qa_ = lq(L.qv, '[data-gb-qv-add]'); if (qa_) { qa_.disabled = !ok; qa_.textContent = ok ? QV_ADD : 'Select a size'; }
        markPills(lq(L.qv, '[data-gb-qv-sizes]'), ok ? pv : null);
      }
    }
    function syncSetModule() { looks.forEach(syncLook); }
    function pickLook(L, v, source) {
      if (!v || !v.available) return;
      L.v = v; L.manual = true;
      syncLook(L);
      track('select_variant', { option: 'look_size', product_id: L.p.id, value: v.size, source: source });
    }
    function buildPills(L, wrap, source, onPick) {
      if (!wrap) return;
      var seen = {};
      L.p.variants.forEach(function (v) {
        if (!v.size || seen[v.size]) return;
        seen[v.size] = true;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gb-pill' + (v.available ? '' : ' out');
        b.textContent = v.size;
        b.dataset.size = v.size;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', 'false');
        if (!v.available) { b.setAttribute('aria-disabled', 'true'); b.title = 'Sold out'; b.setAttribute('aria-label', 'Size ' + v.size + ' — sold out'); }
        b.addEventListener('click', function () { pickLook(L, v, source); if (onPick && v.available) onPick(); });
        wrap.appendChild(b);
      });
    }
    function addLook(L, btn, done) {
      var pv = L.v;
      if (!pv || !pv.available) return;
      btn.disabled = true;
      addItems([{ id: pv.id, quantity: 1, properties: saleProps((cfg.finalSaleIds || []).indexOf(L.p.id) > -1, { '_gb_look': data.handle }) }], function () {
        btn.disabled = false;
        track('add_to_cart', { source: 'complete_the_look', product_id: L.p.id, variant_id: pv.id, price: pv.price });
        if (done) done();
      }, function () { btn.disabled = false; });
    }
    /* Mobile sheet: drag down from the handle (or from anywhere once the sheet is scrolled to the top)
       to close it. Sideways swipes on the photo row are left alone. */
    function sheetDrag(qv, close) {
      var box = qv.querySelector('.gb-qv-box'), bg = qv.querySelector('.gb-qv-bg');
      if (!box) return;
      var y0 = null, x0 = 0, dy = 0, t0 = 0, active = false, decided = false;
      function reset() {
        box.classList.remove('gb-dragging');
        box.style.transition = ''; box.style.transform = '';
        if (bg) { bg.style.transition = ''; bg.style.opacity = ''; }
      }
      box.addEventListener('touchstart', function (e) {
        if (!window.matchMedia('(max-width: 749px)').matches || e.touches.length !== 1) return;
        var t = e.touches[0];
        var inGrab = t.clientY - box.getBoundingClientRect().top < 44;
        if (!inGrab && (box.scrollTop > 0 || (e.target.closest && e.target.closest('[data-gb-qv-rail]')))) return;
        if (e.target.closest && e.target.closest('.gb-qv-close')) return;
        y0 = t.clientY; x0 = t.clientX; dy = 0; t0 = Date.now();
        decided = inGrab; active = inGrab;
      }, { passive: true });
      box.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        var t = e.touches[0], ddy = t.clientY - y0, ddx = t.clientX - x0;
        if (!decided) {
          if (Math.abs(ddy) < 6 && Math.abs(ddx) < 6) return;
          decided = true;
          active = ddy > 0 && Math.abs(ddy) > Math.abs(ddx);
          if (!active) { y0 = null; return; }
        }
        if (!active) return;
        dy = Math.max(0, ddy);
        box.classList.add('gb-dragging');
        box.style.transition = 'none';
        box.style.transform = 'translateY(' + dy + 'px)';
        if (bg) { bg.style.transition = 'none'; bg.style.opacity = String(Math.max(0.2, 1 - dy / (box.offsetHeight || 600))); }
        if (e.cancelable) e.preventDefault();
      }, { passive: false });
      function end() {
        if (y0 === null) return;
        y0 = null;
        if (!active) return;
        active = false;
        var fast = dy / Math.max(1, Date.now() - t0) > 0.5;
        box.style.transition = 'transform .22s cubic-bezier(.2,.8,.2,1)';
        if (bg) bg.style.transition = 'opacity .22s ease';
        if (dy > 110 || (fast && dy > 30)) {
          box.style.transform = 'translateY(100%)';
          if (bg) bg.style.opacity = '0';
          setTimeout(function () { close(); reset(); }, 220);
          track('quick_view_close', { method: 'swipe' });
        } else {
          box.style.transform = '';
          if (bg) bg.style.opacity = '';
          setTimeout(reset, 230);
        }
      }
      box.addEventListener('touchend', end);
      box.addEventListener('touchcancel', end);
    }
    qa('[data-gb-set]').forEach(function (el) {
      var i = parseInt(el.dataset.idx, 10);
      var p = data.setPartners && data.setPartners[i];
      if (!p) return;
      var L = { i: i, el: el, p: p, qv: root.querySelector('[data-gb-qv][data-idx="' + i + '"]'), v: null, manual: false, oneSize: el.hasAttribute('data-one-size') };
      looks.push(L);
      var sizesWrap = lq(el, '[data-gb-set-sizes]');
      var changeBtn = lq(el, '[data-gb-set-change]');
      if (sizesWrap && changeBtn) {
        buildPills(L, sizesWrap, 'card', function () { sizesWrap.classList.remove('open'); changeBtn.setAttribute('aria-expanded', 'false'); });
        changeBtn.addEventListener('click', function () {
          var open = sizesWrap.classList.toggle('open');
          changeBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      var addBtn = lq(el, '[data-gb-set-add]');
      addBtn.addEventListener('click', function () {
        if (L.v && L.v.available) { addLook(L, addBtn); return; }
        if (sizesWrap && changeBtn && !sizesWrap.classList.contains('open')) changeBtn.click();
      });

      /* quick view (photo / name) */
      var qv = L.qv;
      if (!qv) return;
      buildPills(L, lq(qv, '[data-gb-qv-sizes]'), 'quick_view');
      var qvMain = lq(qv, '[data-gb-qv-main]');
      qv.querySelectorAll('[data-gb-qv-thumbs] button').forEach(function (t) {
        t.addEventListener('click', function () {
          qvMain.src = t.dataset.full;
          qv.querySelectorAll('[data-gb-qv-thumbs] button').forEach(function (x) { x.classList.toggle('sel', x === t); });
        });
      });
      var qvLast = null;
      function qvOpen(e) {
        if (e) e.preventDefault();
        qvLast = document.activeElement;
        syncLook(L);
        qv.hidden = false; qv.classList.add('open');
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.classList.add('gb-modal-open');
        var rail = qv.querySelector('[data-gb-qv-rail]'); if (rail) rail.scrollLeft = 0;
        var c = qv.querySelector('.gb-qv-close'); if (c) c.focus();
        track('quick_view_open', { product_id: p.id, source: 'complete_the_look' });
      }
      function qvClose() {
        qv.classList.remove('open'); qv.hidden = true;
        document.documentElement.style.overflow = '';
        document.documentElement.classList.remove('gb-modal-open');
        if (qvLast && qvLast.focus) qvLast.focus();
      }
      sheetDrag(qv, qvClose);
      el.querySelectorAll('[data-gb-qv-open]').forEach(function (b) { b.addEventListener('click', qvOpen); });
      qv.querySelectorAll('[data-gb-qv-close]').forEach(function (b) { b.addEventListener('click', qvClose); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qv.classList.contains('open')) qvClose(); });
      var qvAdd = lq(qv, '[data-gb-qv-add]');
      qvAdd.addEventListener('click', function () { addLook(L, qvAdd, qvClose); });
    });

    /* arrows + counter when there is more than one piece (swipe works too) */
    var lookTrack = q('[data-gb-looktrack]');
    var lookPrev = q('[data-gb-look-prev]');
    var lookNext = q('[data-gb-look-next]');
    var lookCount = q('[data-gb-look-count]');
    if (lookTrack && looks.length > 1) {
      var lookStep = function () { var c = lookTrack.firstElementChild; return c ? c.getBoundingClientRect().width + 12 : lookTrack.clientWidth; };
      var lookIdx = function () { return Math.max(0, Math.min(looks.length - 1, Math.round(lookTrack.scrollLeft / lookStep()))); };
      var lookPaint = function () {
        var i = lookIdx();
        if (lookCount) lookCount.textContent = (i + 1) + ' / ' + looks.length;
        if (lookPrev) lookPrev.disabled = i <= 0;
        if (lookNext) lookNext.disabled = i >= looks.length - 1;
      };
      var lookGo = function (d) {
        var i = Math.max(0, Math.min(looks.length - 1, lookIdx() + d));
        lookTrack.scrollTo({ left: i * lookStep(), behavior: 'smooth' });
        track('complete_the_look_browse', { index: i });
      };
      if (lookPrev) lookPrev.addEventListener('click', function () { lookGo(-1); });
      if (lookNext) lookNext.addEventListener('click', function () { lookGo(1); });
      var lookT;
      lookTrack.addEventListener('scroll', function () { clearTimeout(lookT); lookT = setTimeout(lookPaint, 60); }, { passive: true });
      lookPaint();
    }
    syncSetModule();

    /* ---------------- buy column: sticky without hiding its lower half ----------------
       When the column is taller than the window, a fixed top:90px would keep "Complete the look"
       and the accordions out of reach until the gallery ends; pin it by its bottom edge instead. */
    var rail = q('.gb-rail');
    if (rail && window.matchMedia) {
      var fitRail = function () {
        if (!window.matchMedia('(min-width: 990px)').matches) { rail.style.top = ''; return; }
        var t = Math.min(90, window.innerHeight - rail.offsetHeight - 24);
        rail.style.top = t + 'px';
      };
      fitRail();
      window.addEventListener('resize', fitRail);
      window.addEventListener('load', fitRail);
      if ('ResizeObserver' in window) new ResizeObserver(fitRail).observe(rail);
    }

    /* ---------------- initial paint + view_item ---------------- */
    updateVariantUI();
    track('view_item', { price: state.variant && state.variant.price });
  })();
